module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo_loop"
  }, [_c('div', {
    staticClass: "player_centre"
  }, [_c('div', {
    staticClass: "player_responsive"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.getSourceIframe,
      "width": "100%",
      "height": "100%",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": "allowfullscreen",
      "webkitallowfullscreen": "true",
      "mozallowfullscreen": "true",
      "frameborder": "0"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-365720a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Demo.vue
// module id = 157
// module chunks = 1